import { Footer } from "./Footer";
import { Header } from "./Header";
import { SuburbiaConfig } from "../types";
import { VideoManager } from "./VideoManager";
import { ArchiveManager } from "./ArchiveManager";
import { PresentationManager } from "./PresentationManager";

declare global {
  interface Window {
    SuburbiaConfig: SuburbiaConfig;
  }
}

export class SuburbiaCore {

  videoObserver!: IntersectionObserver;

  constructor() {
    new Header();
    new Footer();
    new VideoManager();

    if (window.SuburbiaConfig.isArchive) {
      new ArchiveManager();
    }

    if (document.body.classList.contains('single-presentation')) {
      new PresentationManager();
    }

    // if (!document.body.classList.contains('archive')) {

    // }
    this.setupIntersectionObservers();

    this.doStringReplacements();

    console.log("%c SUBURBIA 2026 %c Made with love by Code With Feeling {♥}", "background:#000;color:#fff;padding:15px;", "background:#fff;color:#000;padding:15px;");
  }

  setupIntersectionObservers() {
    // Group blocks
    const groups = Array.from(document.querySelectorAll('.wp-block-group'));
    const galleries: HTMLElement[] = Array.from(document.querySelectorAll('.wp-block-gallery'));
    const archiveImages: HTMLElement[] = Array.from(document.querySelectorAll('.archive .wp-block-image'));
    const targetElements = [...groups, ...galleries, ...archiveImages];

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('show-group');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });

    galleries.forEach((gallery, index) => {
      gallery.style.setProperty("--swipe-hint-delay", `${3 + index * 1.7}s`);
    });

    targetElements.forEach(target => {
      this.applyDelaysToGroupChildren(target as HTMLElement);
      observer.observe(target);
    });
  }

  doStringReplacements() {
    const allElements = document.querySelectorAll('p');
    const elementsArray: HTMLElement[] = Array.from(allElements);

    // Only work on paragraphs that contain the [at] or [dot] strings
    const elementsToReplace = elementsArray.filter((el) => {
      return el.innerHTML.includes('[at]') || el.innerHTML.includes('[dot]');
    });

    elementsToReplace.forEach((el) => {
      if (el.innerHTML.includes('[at]')) {
        // const subject = el.innerHTML.split('?subject=')[1] ?? 'Web Enquiry';
        el.innerHTML = el.innerHTML.replace(/\s?\[at\]\s?/g, '@').replace(/\s?\[dot\]\s?/g, '.');

        // Email address regex
        const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/g;
        const emailMatches = el.innerHTML.match(emailRegex);

        if (emailMatches) {
          emailMatches.forEach((email) => {
            el.innerHTML = el.innerHTML
              .replace(/\?subject.*/, '') // Remove any existing subject query
              .replace(email, `<a class="anim-u" href="mailto:${email}?subject=Hello"><span class="anim-u-target from-current to-current">${email}</span></a>`);
          });
        }
      }
    });
  }

  applyDelaysToGroupChildren(group: HTMLElement) {
    Array.from(group.children).forEach((child, index) => {
      const delay = index * window.SuburbiaConfig.baseDelay!;
      (child as HTMLElement).style.setProperty('--delay', `${delay}ms`);
    });
  }
}
